<div class="slideout-content">
    <!-- Modal to add new user starts-->
    <div
      class="modalsd modal-slide-in sdfade add-payment-modal"
      id="modals-slide-in"
    >
      <div class="modal-dialog sidebar-lg">
        <div class="modal-content p-0">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            (click)="toggleSidebar('modal-directory-list')"
            
          >
            ×
          </button>
          <div class="modal-header mb-1">
            <h5 class="modal-title">
              <span class="align-middle">Phone Directory</span>
            </h5>
          </div>
          <div class="modal-body flex-grow- 1">
            test
          </div>
        </div>
      </div>
    </div>
    <!-- Modal to add new user Ends-->
  </div>
  